<template>
  <v-container>
    <v-stepper v-model="stepReal" vertical>
      <v-img class="ml-6 mt-6 logo" src="/logo.svg"/>
      <v-stepper-step :complete="stepReal > 1" step="1" editable>
        Выберите комнату и тип окна
      </v-stepper-step>

      <v-stepper-content step="1">
        <TypeWindow1 />
        <Btn1 />
        <TypeWindow2 v-if="this.$store.state.Window1.addWindow2"/>
        <Btn2 v-if="this.$store.state.Window1.addWindow2"/>
        <TypeWindow3 v-if="this.$store.state.Window2.addWindow3"/>
        <Btn3 v-if="this.$store.state.Window2.addWindow3"/>
        <TypeWindow4 v-if="this.$store.state.Window3.addWindow4"/>
        <Btn4 v-if="this.$store.state.Window3.addWindow4"/>
        <TypeWindow5 v-if="this.$store.state.Window4.addWindow5"/>
        <Btn5 v-if="this.$store.state.Window4.addWindow5"/>
        <TypeWindow6 v-if="this.$store.state.Window5.addWindow6"/>

        <v-btn
          color="primary"
          @click="stepReal = 2"
          :disabled="!this.$store.state.Window1.nameWindow1 || !this.$store.state.Window1.widthWindow1 || !this.$store.state.Window1.heightWindow1 || !this.$store.state.Window1.windowTypeSelected1"
        >
          Продолжить
        </v-btn>
        <v-btn text >Отмена</v-btn>
      </v-stepper-content>

      <v-stepper-step :complete="stepReal > 2" step="2" editable>Выберите цвет стен</v-stepper-step>

      <v-stepper-content step="2">
        <ColorPickerRoom1 />
        <ColorPickerRoom2
          v-if="this.$store.state.Window1.addWindow2"
        />
        <ColorPickerRoom3
          v-if="this.$store.state.Window2.addWindow3"
        />
        <ColorPickerRoom4
          v-if="this.$store.state.Window3.addWindow4"
        />
        <ColorPickerRoom5
          v-if="this.$store.state.Window4.addWindow5"
        />
        <ColorPickerRoom6
          v-if="this.$store.state.Window5.addWindow6"
        />
        <v-btn color="primary" @click="stepReal = 3">Продолжить</v-btn>
        <v-btn text @click="stepReal = 1">Отмена</v-btn>
      </v-stepper-content>

      <v-stepper-step :complete="stepReal > 3" step="3" editable>Выберитие комплект штор</v-stepper-step>

      <v-stepper-content step="3">
        <kitCurtain1 />
        <kitCurtain2 v-if="this.$store.state.Window1.addWindow2"/>
        <kitCurtain3 v-if="this.$store.state.Window1.addWindow2 && this.$store.state.Window2.addWindow3"/>
        <kitCurtain4 v-if="this.$store.state.Window1.addWindow2 && this.$store.state.Window2.addWindow3 && this.$store.state.Window3.addWindow4"/>
        <kitCurtain5 v-if="this.$store.state.Window1.addWindow2 && this.$store.state.Window2.addWindow3 && this.$store.state.Window3.addWindow4 && this.$store.state.Window4.addWindow5"/>
        <kitCurtain6 v-if="this.$store.state.Window1.addWindow2 && this.$store.state.Window2.addWindow3 && this.$store.state.Window3.addWindow4 && this.$store.state.Window4.addWindow5 && this.$store.state.Window5.addWindow6"/>
        <h3 class="float-right" v-if="costStep3Summ && this.$store.state.Curtains.modelCurtain1">Стоимость: {{ costStep3Summ }} руб.</h3>
        <v-btn color="primary" @click="stepReal = 4">Продолжить</v-btn>
        <v-btn text>Отмена</v-btn>
      </v-stepper-content>

      <v-stepper-step :complete="stepReal > 4" step="4" editable>Выберите тюль</v-stepper-step>
      <v-stepper-content step="4">
        <kitTulle1 />
        <kitTulle2 v-if="this.$store.state.Window1.addWindow2"/>
        <kitTulle3 v-if="this.$store.state.Window1.addWindow2 && this.$store.state.Window2.addWindow3"/>
        <kitTulle4 v-if="this.$store.state.Window1.addWindow2 && this.$store.state.Window2.addWindow3 && this.$store.state.Window3.addWindow4"/>
        <kitTulle5 v-if="this.$store.state.Window1.addWindow2 && this.$store.state.Window2.addWindow3 && this.$store.state.Window3.addWindow4 && this.$store.state.Window4.addWindow5"/>
        <kitTulle6 v-if="this.$store.state.Window1.addWindow2 && this.$store.state.Window2.addWindow3 && this.$store.state.Window3.addWindow4 && this.$store.state.Window4.addWindow5 && this.$store.state.Window5.addWindow6"/>
        <h3 class="float-right">Стоимость: {{ costStep3Summ + costStep4Summ }} руб.</h3>
        <v-btn color="primary" @click="stepReal = 5">Продолжить</v-btn>
        <v-btn text>Отмена</v-btn>
      </v-stepper-content>

      <v-stepper-step :complete="stepReal > 5" step="5" editable>Выберите карниз</v-stepper-step>
      <v-stepper-content step="5">
        <TypeKarniz1 />
        <TypeKarniz2 v-if="this.$store.state.Window1.addWindow2"/>
        <TypeKarniz3 v-if="this.$store.state.Window1.addWindow2 && this.$store.state.Window2.addWindow3"/>
        <TypeKarniz4 v-if="this.$store.state.Window1.addWindow2 && this.$store.state.Window2.addWindow3 && this.$store.state.Window3.addWindow4"/>
        <TypeKarniz5 v-if="this.$store.state.Window1.addWindow2 && this.$store.state.Window2.addWindow3 && this.$store.state.Window3.addWindow4 && this.$store.state.Window4.addWindow5"/>
        <TypeKarniz6 v-if="this.$store.state.Window1.addWindow2 && this.$store.state.Window2.addWindow3 && this.$store.state.Window3.addWindow4 && this.$store.state.Window4.addWindow5 && this.$store.state.Window5.addWindow6"/>
        <h3 class="float-right">Стоимость: {{ costStep3Summ + costStep4Summ + costStep5Summ }} руб.</h3>
        <v-btn color="primary" @click="stepReal = 6">Продолжить</v-btn>
        <v-btn text>Отмена</v-btn>
      </v-stepper-content>

      <v-stepper-step :complete="stepReal > 6" step="6" editable>Дополнительные услуги</v-stepper-step>
      <v-stepper-content step="6">
        <add1 />
        <add2 v-if="this.$store.state.Window1.addWindow2"/>
        <add3 v-if="this.$store.state.Window1.addWindow2 && this.$store.state.Window2.addWindow3"/>
        <add4 v-if="this.$store.state.Window1.addWindow2 && this.$store.state.Window2.addWindow3 && this.$store.state.Window3.addWindow4"/>
        <add5 v-if="this.$store.state.Window1.addWindow2 && this.$store.state.Window2.addWindow3 && this.$store.state.Window3.addWindow4 && this.$store.state.Window4.addWindow5"/>
        <add6 v-if="this.$store.state.Window1.addWindow2 && this.$store.state.Window2.addWindow3 && this.$store.state.Window3.addWindow4 && this.$store.state.Window4.addWindow5 && this.$store.state.Window5.addWindow6"/>
        <h3 class="float-right">Стоимость: {{ costStep3Summ + costStep4Summ + costStep5Summ + costStep6Summ }} руб.</h3>
        <v-btn color="primary" @click="stepSeven() || finalCostCalc()">Продолжить</v-btn>
        <v-btn text>Отмена</v-btn>
      </v-stepper-content>

      <v-stepper-step step="7" editable @click="finalCostCalc()">Оформите заявку</v-stepper-step>
      <v-stepper-content step="7" class="mb-5 mt-5">
        <Order class="mb-5"/>
        <v-btn color="primary" @click.once="onSubmit() || onSubmitTelegram() || openDialog()" :disabled="!this.$store.state.Final.name || !this.$store.state.Final.phone">Отправить</v-btn>
        <v-btn color="secondary" class="float-right d-none d-sm-flex d-md-flex" @click="printNow()">Печать заказа</v-btn>
        <v-btn text @click="stepReal = 7">Отмена</v-btn>
      </v-stepper-content>
    </v-stepper>
    <Modal />
  </v-container>
</template>

<script>
import TypeWindow1 from './TypeWindow1'
import TypeWindow2 from './TypeWindow2'
import TypeWindow3 from './TypeWindow3'
import TypeWindow4 from './TypeWindow4'
import TypeWindow5 from './TypeWindow5'
import TypeWindow6 from './TypeWindow6'
import Btn1 from './Btn1'
import Btn2 from './Btn2'
import Btn3 from './Btn3'
import Btn4 from './Btn4'
import Btn5 from './Btn5'
import ColorPickerRoom1 from './ColorPickerRoom1'
import ColorPickerRoom2 from './ColorPickerRoom2'
import ColorPickerRoom3 from './ColorPickerRoom3'
import ColorPickerRoom4 from './ColorPickerRoom4'
import ColorPickerRoom5 from './ColorPickerRoom5'
import ColorPickerRoom6 from './ColorPickerRoom6'
import kitCurtain1 from './kitCurtain1'
import kitCurtain2 from './kitCurtain2'
import kitCurtain3 from './kitCurtain3'
import kitCurtain4 from './kitCurtain4'
import kitCurtain5 from './kitCurtain5'
import kitCurtain6 from './kitCurtain6'
import kitTulle1 from './kitTulle1'
import kitTulle2 from './kitTulle2'
import kitTulle3 from './kitTulle3'
import kitTulle4 from './kitTulle4'
import kitTulle5 from './kitTulle5'
import kitTulle6 from './kitTulle6'
import TypeKarniz1 from './TypeKarniz1'
import TypeKarniz2 from './TypeKarniz2'
import TypeKarniz3 from './TypeKarniz3'
import TypeKarniz4 from './TypeKarniz4'
import TypeKarniz5 from './TypeKarniz5'
import TypeKarniz6 from './TypeKarniz6'
import add1 from './add1'
import add2 from './add2'
import add3 from './add3'
import add4 from './add4'
import add5 from './add5'
import add6 from './add6'
import Order from './Order'
import Modal from './Modal'
import axios from 'axios'
export default {
  name: 'Calc',
  components: {
    TypeWindow1, TypeWindow2, TypeWindow3, TypeWindow4, TypeWindow5, TypeWindow6, Btn1, Btn2, Btn3, Btn4, Btn5, ColorPickerRoom1, ColorPickerRoom2, ColorPickerRoom3, ColorPickerRoom4, ColorPickerRoom5, ColorPickerRoom6, kitCurtain1, kitCurtain2, kitCurtain3, kitCurtain4, kitCurtain5, kitCurtain6, kitTulle1, kitTulle2, kitTulle3, kitTulle4, kitTulle5, kitTulle6, TypeKarniz1, TypeKarniz2, TypeKarniz3, TypeKarniz4, TypeKarniz5, TypeKarniz6, add1, add2, add3, add4, add5, add6, Order, Modal
  },
  data () {
    return {
      stepReal: 1,
      sent: false
    }
  },
  mounted () {
    this.$vuetify.theme.themes.light.primary = '#d9002a'
  },
  computed: {
    costStep3Summ () {
      return this.$store.state.Window1.costStep1Window1 + this.$store.state.Window2.costStep1Window2 + this.$store.state.Window3.costStep1Window3 + this.$store.state.Window4.costStep1Window4 + this.$store.state.Window5.costStep1Window5 + this.$store.state.Window6.costStep1Window6
    },
    costStep4Summ () {
      return this.$store.state.Tulles.costTulle1 + this.$store.state.Tulles.costTulle2 + this.$store.state.Tulles.costTulle3 + this.$store.state.Tulles.costTulle4 + this.$store.state.Tulles.costTulle5 + this.$store.state.Tulles.costTulle6
    },
    costStep5Summ () {
      return this.$store.state.Karniz.costKarniz1 + this.$store.state.Karniz.costKarniz2 + this.$store.state.Karniz.costKarniz3 + this.$store.state.Karniz.costKarniz4 + this.$store.state.Karniz.costKarniz5 + this.$store.state.Karniz.costKarniz6
    },
    costStep6Summ () {
      return this.$store.state.AddOptions.costAdd1 + this.$store.state.AddOptions.costAdd2 + this.$store.state.AddOptions.costAdd3 + this.$store.state.AddOptions.costAdd4 + this.$store.state.AddOptions.costAdd5 + this.$store.state.AddOptions.costAdd6
    }
  },
  methods: {
    finalCostCalc () {
      this.$store.commit('finalCostUpdate')
    },
    stepSeven () {
      this.stepReal = 7
    },
    onSubmit () {
      axios.post('/mail.php',
        this.$store.state
      )
        .then(response => (response.data))
        .catch(function (error) {
          console.log(error)
        })
    },
    onSubmitTelegram () {
      axios.post('/telegram.php',
        this.$store.state
      )
        .then(function (response) {
          console.log(response)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    openDialog () {
      this.$store.commit('updateDialog')
      setTimeout(this.reloadPage, 3000)
    },
    reloadPage () {
      location.reload()
    },
    printNow (value) {
      this.print = value
      window.print()
    }
  }
}
</script>

<style>
.summaryCol {
  border-left: 1px solid rgba(0,0,0,.12);
}
.logo {
  width: 20%;
}
@media (min-width: 1264px) {
}
@media (max-width: 320px) {
  .logo {
    width: 40%;
  }
}
@media (max-width: 375px) {
  .logo {
    width: 40%;
  }
}
@media (max-width: 332px) {
}
@media (max-width: 1336px) {

}
</style>
